import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, tap } from 'rxjs';
import { AutoSavePersistService } from 'common/auto-save/auto-save-persist.service';
import { evictEmailConversation } from '../actions/email-conversation.actions';
import { getEmailDraftStorageKey, getEmailFooterModeStorageKey } from '../helpers/email-drafts.helpers';

@Injectable({
  providedIn: 'root'
})
export class GenesysCloudEmailDraftsEffects {
  readonly clearEmailDraft$ = createEffect(() => this.actions$.pipe(
    ofType(evictEmailConversation),
    map(({ conversationId }) => [ getEmailDraftStorageKey(conversationId), getEmailFooterModeStorageKey(conversationId) ]),
    tap(([ emailDraftKey, emailFooterStateDraftKey ]) => {
      this.autoSavePersistService.clear(emailDraftKey);
      this.autoSavePersistService.clear(emailFooterStateDraftKey);
    })
  ), { dispatch: false });

  constructor(private readonly actions$: Actions,
              private readonly autoSavePersistService: AutoSavePersistService) {
  }
}
